export const PHONE_COUNTRY_CODE_OPTIONS = [
  { value: '+91', label: 'India (+91)' },
  { value: '+1', label: 'US / Canada (+1)' },
  { value: '+44', label: 'United Kingdom (+44)' },
  { value: '+61', label: 'Australia (+61)' },
  { value: '+971', label: 'UAE (+971)' },
  { value: '+65', label: 'Singapore (+65)' },
  { value: '+81', label: 'Japan (+81)' },
  { value: '+49', label: 'Germany (+49)' },
  { value: '+33', label: 'France (+33)' },
  { value: '+977', label: 'Nepal (+977)' },
  { value: '+94', label: 'Sri Lanka (+94)' },
  { value: '+880', label: 'Bangladesh (+880)' },
  { value: '+60', label: 'Malaysia (+60)' },
  { value: '+64', label: 'New Zealand (+64)' },
] as const

export const DEFAULT_PHONE_COUNTRY_CODE = '+91'
